import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BsLinkedin, BsYoutube, BsFacebook } from 'react-icons/bs';
import './footer.css';

const menus = ['Home', 'Products', 'About Us', 'Contact Us'];
const products = ['Family Pack', 'Combo Pack', 'Sky Shots', 'Ground Crackers', 'Small Crackers'];

export const Footer = () => {
  return (
    <footer className="footer" id="footer">
      <Container fluid className="px-4 px-md-5">
        <Row className="footer__top g-4">

          {/* Col 1 — Brand */}
          <Col xs={12} sm={6} lg={3}>
            <h3 className="footer__logo">SmartCrackers</h3>
            <p className="footer__desc">
              Your trusted destination for premium quality crackers. Celebrate every occasion with safe, licensed, and vibrant fireworks delivered to your doorstep.
            </p>
          </Col>

          {/* Col 2 — Menus */}
          <Col xs={6} sm={6} lg={3}>
            <h5 className="footer__heading">Quick Links</h5>
            <ul className="footer__list">
              {menus.map((item) => (
                <li key={item}><a href="#" className="footer__link">{item}</a></li>
              ))}
            </ul>
          </Col>

          {/* Col 3 — Products */}
          <Col xs={6} sm={6} lg={3}>
            <h5 className="footer__heading">Products</h5>
            <ul className="footer__list">
              {products.map((item) => (
                <li key={item}><a href="#" className="footer__link">{item}</a></li>
              ))}
            </ul>
          </Col>

          {/* Col 4 — Contact */}
          <Col xs={12} sm={6} lg={3}>
            <h5 className="footer__heading">Contact Us</h5>
            <ul className="footer__list footer__list--contact">
              <li>
                <span className="footer__contact-icon">📍</span>
                3A smart crackers , RSK FANCY Agency, Kalugumalai Road , Vembakottai Sivakasi -626131
              </li>
              <li>
                <span className="footer__contact-icon">📞</span>
                <a href="tel:+917530054491" className="footer__link">+91 75300 54491</a>
              </li>
              <li>
                <span className="footer__contact-icon">✉️</span>
                <a href="mailto:smart3acrackers@gmail.com" className="footer__link">smart3acrackers@gmail.com</a>
              </li>
            </ul>
          </Col>

        </Row>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <p className="footer__copy">
            © 2026 All Rights Reserved. <span className="footer__dev-link" >SmartCrackers</span> &nbsp;|&nbsp; Developed by{' '}
            <a href="https://sanjayj.netlify.app/" target="_blank" rel="noopener noreferrer" className="footer__dev-link">
              Sanjay J
            </a>
          </p>
          <div className="footer__socials">
            <a href="https://www.youtube.com/@mathanraja8782" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="footer__social-icon footer__social-icon--yt">
              <BsYoutube size={20} />
            </a>
            <a href="https://www.facebook.com/share/r/1CEerpsxKH/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer__social-icon footer__social-icon--fb">
              <BsFacebook size={18} />
            </a>
          </div>
        </div>

      </Container>
    </footer>
  );
};
